import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from 'src/app/components/dialog-box/mat-dialog/mat-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from 'src/app/core/auth.service';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ProductCardsLandingComponent } from '../product-cards-landing/product-cards-landing.component';
import { CustomerCardLandingComponent } from '../customer-card-landing/customer-card-landing.component';
import { MyPolicyCardListComponent } from '../my-policy-card-list/my-policy-card-list.component';
import { ArticleCardLandingComponent } from '../article-card-landing/article-card-landing.component';
import { ChatbotComponent } from 'src/app/chatbot/chatbot.component';

@Component({
  selector: 'app-registerform-landing',
  templateUrl: './registerform-landing.component.html',
  styleUrls: ['./registerform-landing.component.scss'],
  standalone:true,
  imports:[
    ProductCardsLandingComponent,
    MyPolicyCardListComponent,
    CustomerCardLandingComponent,
    ArticleCardLandingComponent,
    ChatbotComponent,
    CommonModule, MatFormFieldModule]

})
export class RegisterformLandingComponent implements OnInit {
  tabs = [
    { label: 'Health', icon: 'fa-solid fa-heart-pulse' },
    { label: 'Car', icon: 'fa-solid fa-car' },
    { label: 'Bike', icon: 'fa-solid fa-bicycle' },
    { label: 'Term Life', icon: 'fa-solid fa-car' },
    { label: 'Taxi', icon: 'fa-solid fa-bus' },
    { label: 'Travel', icon: 'fa-solid fa-plane' }

  ];
  activeTab = this.tabs[0]; 

  setActiveTab(tab: any) {
    this.activeTab = tab;
  }
  quotationForm:FormGroup;
  isSubmitted:boolean=false;
  phoneCodes:any=[];
  afrisureCards:any=[
    {icon:"zerocapex", label:"Zero Capex" ,p:"Lorem ipsum dolor sit amet,consectetur adipiscing elit. "},
    {icon:"lowcost",label:"Lower Cost" ,p:"Lorem ipsum dolor sit amet, consectetur adipiscing elit.  "},

    {icon:"experience",label:"17 yrs Experience" ,p:"Lorem ipsum dolor sit amet,consectetur adipiscing elit. "},

    {icon:"completetran",label:"Complete Transparency" ,p:"Lorem ipsum dolor sit amet,consectetur adipiscing elit. "},

    {icon:"empathy",label:"Empathy for Our Customers" ,p:"Lorem ipsum dolor sit amet,consectetur adipiscing elit. "},
    {icon:"dependence",label:"No IT Dependence" ,p:"Lorem ipsum dolor sit amet,consectetur adipiscing elit. "},

  ]

  constructor(
    private fb:FormBuilder,
    private loader:LoaderService,
    private restService:RestService,
    private dialog: MatDialog,
    private authService: AuthService,

    private breakpointObserver: BreakpointObserver
  ) {  }
 

   ngOnInit(): void {
    this.loader.show();
    this.quotationForm = this.fb.group({
      name: [null],
      email: [null, [ Validators.email, Validators.pattern(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)]],
      countryCode: ['+254'],
      phoneNumber: [null, [ Validators.minLength(9), Validators.maxLength(10)]],
      dateOfBirth:[null],
      gender:['']
    });
   // this.loadPhoneCodes();
// this.signUp();
  
  }

 signUp(){
  let dialogRef = this.dialog.open(SignUpComponent, {
    width: '500px',
    height:'auto',
    disableClose: true,
    autoFocus:false,
    data: {
      isResultValid: true,

    }
  })
 }

  loadPhoneCodes() {
    this.loader.show();
    this.phoneCodes = [];
    this.restService.getPhoneCode().subscribe((responsedata: any[]) => {
      this.phoneCodes = responsedata;
       this.loader.hide();
    });
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  getStartedSubmit(){

  }











}
